import axios, { AxiosRequestConfig } from 'axios'
import {
  api_feedbacks_path,
  overview_api_production_planning_index_path, sync_job_number_api_production_planning_index_path
} from '../routes'

export function getProductionPlanningOverview(payload = {}) {
  const options: AxiosRequestConfig = {
    url: overview_api_production_planning_index_path({ format: 'json' }),
    method: 'get',
    responseType: 'json',
    params: payload,
  }
  return axios(options).then(response => response.data)
}

export function syncJobNumber(payload) {
  const options: AxiosRequestConfig = {
    url: sync_job_number_api_production_planning_index_path({ format: 'json' }),
    method: 'post',
    responseType: 'json',
    data: payload,
  }
  return axios(options).then(response => response.data)
}
